module.exports = __webpack_public_path__ + "static/media/template-1.d4abbf04.svg";